module.exports = __webpack_public_path__ + "static/media/feed-screen.4f52b737.jpeg";